// src/pages/Dashboard.jsx
import React, { useContext } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "../components/sidebar";
import ChatWindow from "../components/chatwindow";
import ChatInput from "../components/chatinput";
import Header from "../components/header";
import { ChatContext } from "../context/chatcontext";
import { useKeyboardShortcuts } from "../utils/keyboardShortcuts";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const { messages, isProcessing, processingMessage, startNewChat } = useContext(ChatContext);
  const hasMessages = messages && messages.length > 0;

  // Keyboard shortcuts
  useKeyboardShortcuts([
    {
      key: "k",
      action: () => startNewChat(),
    },
    {
      key: ",",
      action: () => navigate("/settings"),
    },
  ]);

  const isDark = theme.palette.mode === "dark";
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        background: "#ffffff",
        color: theme.palette.text.primary,
        overflow: "hidden",
      }}
    >
      {/* 🧭 Fixed Header */}
      <Header />

      {/* 🧩 Main layout - starts below header */}
      <Box
        sx={{
          display: "flex",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          flexDirection: { xs: "column", md: "row" },
          mt: "64px", // Header height
          boxSizing: "border-box",
        }}
      >
        {/* Sidebar */}
        <Box
          sx={{
            display: { xs: isMobile ? "none" : "block", md: "block" },
            width: { xs: "100%", md: 260 },
            height: "calc(100vh - 64px)", // Full height minus header
            overflowY: "auto",
            overflowX: "hidden",
            background: "#f8fafc",
          }}
        >
          <Sidebar />
        </Box>
        
        {/* Chat Area */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            borderLeft: { xs: "none", md: "1px solid #e2e8f0" },
            minHeight: 0,
            overflow: "hidden",
            width: { xs: "100%", md: "auto" },
            height: "calc(100vh - 64px)", // Full height minus header
            background: "#ffffff",
          }}
        >
          <ChatWindow messages={messages} />
          {isProcessing && (
            <Box
              sx={{
                textAlign: "center",
                py: 0.5,
                px: 2,
                color: theme.palette.primary.main,
                fontStyle: "italic",
                fontSize: "0.85rem",
              }}
            >
              {processingMessage}
            </Box>
          )}
          {hasMessages && <ChatInput />}
        </Box>
      </Box>
    </Box>
  );
}
